import type {CurrencyType} from 'web-app/react/bookings-finance/contexts/currency-formatter-context/types/currency.type';
import type {FormattedLocalType} from 'web-app/react/bookings-finance/contexts/currency-formatter-context/types/formatted-locale.type';
import type {CoreCountryType} from 'web-app/react/bookings-finance/contexts/currency-formatter-context/types/core-country.type';

type FormattedCountryDataType = {
    locale: FormattedLocalType;
    currency: CurrencyType;
};

/**
 * Returns locale and currency information based on the provided country.
 *
 * @param country - The country code or name to get locale and currency information for
 * @returns An object containing the locale string and currency code appropriate for the country
 */
export function getLocaleAndCurrencyFromCountry(country: CoreCountryType): FormattedCountryDataType {
    switch (country) {
        case 'Denmark':
            return {locale: 'da-DK', currency: 'DKK'};
        case 'Bahrain':
        case 'UK':
            return {locale: 'en-GB', currency: 'GBP'};
        case 'Germany':
        case 'Austria':
            return {locale: 'de-DE', currency: 'EUR'};
        case 'US':
        case 'Brazil':
        case 'UAE':
            return {locale: 'en-US', currency: 'USD'};
        case 'Bermuda':
            return {locale: 'en-GB', currency: 'BMD'};
        case 'Canada':
            return {locale: 'en-GB', currency: 'CAD'};
        case 'Spain':
            return {locale: 'es-ES', currency: 'EUR'};
        case 'Ireland':
            return {locale: 'en-IE', currency: 'EUR'};
        case 'Switzerland':
            return {locale: 'de-CH', currency: 'CHF'};
        case 'Thailand':
            return {locale: 'th-TH', currency: 'THB'};
        case 'Oman':
            return {locale: 'en-US', currency: 'OMR'};
        case 'Kuwait':
            return {locale: 'en-GB', currency: 'KWD'};
        case 'Qatar':
            return {locale: 'en-GB', currency: 'QAR'};
        case 'Poland':
            return {locale: 'pl-PL', currency: 'PLN'};
        case 'China':
            return {locale: 'zh-CN', currency: 'CNY'};
        case 'India':
            return {locale: 'en-IN', currency: 'INR'};
        case 'France':
            return {locale: 'fr-FR', currency: 'EUR'};
        case 'Norway':
            return {locale: 'no-NO', currency: 'NOK'};
        case 'Hong Kong':
            return {locale: 'en-GB', currency: 'HKD'};
        case 'Greece':
            return {locale: 'el-GR', currency: 'EUR'};
        case 'Ghana':
            return {locale: 'en-GH', currency: 'GHS'};
        default:
            return {locale: 'en-US', currency: 'USD'};
    }
}
